var map = {
	"./address-book.svg": "./src/assets/images/svg/address-book.svg",
	"./asterisk.svg": "./src/assets/images/svg/asterisk.svg",
	"./bell.svg": "./src/assets/images/svg/bell.svg",
	"./cabinet.svg": "./src/assets/images/svg/cabinet.svg",
	"./calendar-check.svg": "./src/assets/images/svg/calendar-check.svg",
	"./calendar-chevron-left.svg": "./src/assets/images/svg/calendar-chevron-left.svg",
	"./calendar-x.svg": "./src/assets/images/svg/calendar-x.svg",
	"./caution.svg": "./src/assets/images/svg/caution.svg",
	"./check-c.svg": "./src/assets/images/svg/check-c.svg",
	"./check-circle.svg": "./src/assets/images/svg/check-circle.svg",
	"./chevron-bottom.svg": "./src/assets/images/svg/chevron-bottom.svg",
	"./chevron-left.svg": "./src/assets/images/svg/chevron-left.svg",
	"./chevron-right.svg": "./src/assets/images/svg/chevron-right.svg",
	"./chevron-top.svg": "./src/assets/images/svg/chevron-top.svg",
	"./chevron.svg": "./src/assets/images/svg/chevron.svg",
	"./clipboard-check.svg": "./src/assets/images/svg/clipboard-check.svg",
	"./clipboard.svg": "./src/assets/images/svg/clipboard.svg",
	"./clock.svg": "./src/assets/images/svg/clock.svg",
	"./close-window.svg": "./src/assets/images/svg/close-window.svg",
	"./close.svg": "./src/assets/images/svg/close.svg",
	"./document-download.svg": "./src/assets/images/svg/document-download.svg",
	"./document.svg": "./src/assets/images/svg/document.svg",
	"./download-circle.svg": "./src/assets/images/svg/download-circle.svg",
	"./download.svg": "./src/assets/images/svg/download.svg",
	"./evaluation.svg": "./src/assets/images/svg/evaluation.svg",
	"./excel-download.svg": "./src/assets/images/svg/excel-download.svg",
	"./excel-upload.svg": "./src/assets/images/svg/excel-upload.svg",
	"./excel.svg": "./src/assets/images/svg/excel.svg",
	"./exclaim.svg": "./src/assets/images/svg/exclaim.svg",
	"./exclamation-triangle.svg": "./src/assets/images/svg/exclamation-triangle.svg",
	"./folder-closed.svg": "./src/assets/images/svg/folder-closed.svg",
	"./folder-opened.svg": "./src/assets/images/svg/folder-opened.svg",
	"./guide.svg": "./src/assets/images/svg/guide.svg",
	"./hand-heart.svg": "./src/assets/images/svg/hand-heart.svg",
	"./icon-mail.svg": "./src/assets/images/svg/icon-mail.svg",
	"./icon-message.svg": "./src/assets/images/svg/icon-message.svg",
	"./icon_shuffle_down.svg": "./src/assets/images/svg/icon_shuffle_down.svg",
	"./icon_shuffle_left.svg": "./src/assets/images/svg/icon_shuffle_left.svg",
	"./icon_shuffle_right.svg": "./src/assets/images/svg/icon_shuffle_right.svg",
	"./icon_shuffle_up.svg": "./src/assets/images/svg/icon_shuffle_up.svg",
	"./img_smile.svg": "./src/assets/images/svg/img_smile.svg",
	"./inbound.svg": "./src/assets/images/svg/inbound.svg",
	"./loader-large.svg": "./src/assets/images/svg/loader-large.svg",
	"./loader-small.svg": "./src/assets/images/svg/loader-small.svg",
	"./location.svg": "./src/assets/images/svg/location.svg",
	"./logo-db-hr.svg": "./src/assets/images/svg/logo-db-hr.svg",
	"./logo-db.svg": "./src/assets/images/svg/logo-db.svg",
	"./logo-douane.svg": "./src/assets/images/svg/logo-douane.svg",
	"./logo-ustra-hr.svg": "./src/assets/images/svg/logo-ustra-hr.svg",
	"./logout.svg": "./src/assets/images/svg/logout.svg",
	"./menu.svg": "./src/assets/images/svg/menu.svg",
	"./mobile-menu.svg": "./src/assets/images/svg/mobile-menu.svg",
	"./negative.svg": "./src/assets/images/svg/negative.svg",
	"./new.svg": "./src/assets/images/svg/new.svg",
	"./people.svg": "./src/assets/images/svg/people.svg",
	"./person-check.svg": "./src/assets/images/svg/person-check.svg",
	"./plant.svg": "./src/assets/images/svg/plant.svg",
	"./positive copy.svg": "./src/assets/images/svg/positive copy.svg",
	"./positive.svg": "./src/assets/images/svg/positive.svg",
	"./presentation.svg": "./src/assets/images/svg/presentation.svg",
	"./print.svg": "./src/assets/images/svg/print.svg",
	"./question-balloon.svg": "./src/assets/images/svg/question-balloon.svg",
	"./question-filled.svg": "./src/assets/images/svg/question-filled.svg",
	"./quick-1.svg": "./src/assets/images/svg/quick-1.svg",
	"./quick-2.svg": "./src/assets/images/svg/quick-2.svg",
	"./quick-3.svg": "./src/assets/images/svg/quick-3.svg",
	"./quick-4.svg": "./src/assets/images/svg/quick-4.svg",
	"./quick-5.svg": "./src/assets/images/svg/quick-5.svg",
	"./quick-6.svg": "./src/assets/images/svg/quick-6.svg",
	"./quick-7.svg": "./src/assets/images/svg/quick-7.svg",
	"./quick-8.svg": "./src/assets/images/svg/quick-8.svg",
	"./receipt.svg": "./src/assets/images/svg/receipt.svg",
	"./refresh.svg": "./src/assets/images/svg/refresh.svg",
	"./round-magnifier.svg": "./src/assets/images/svg/round-magnifier.svg",
	"./search-user.svg": "./src/assets/images/svg/search-user.svg",
	"./search.svg": "./src/assets/images/svg/search.svg",
	"./settings-filled.svg": "./src/assets/images/svg/settings-filled.svg",
	"./star.svg": "./src/assets/images/svg/star.svg",
	"./state-1.svg": "./src/assets/images/svg/state-1.svg",
	"./state-2.svg": "./src/assets/images/svg/state-2.svg",
	"./state-3.svg": "./src/assets/images/svg/state-3.svg",
	"./state-4.svg": "./src/assets/images/svg/state-4.svg",
	"./subtitle.svg": "./src/assets/images/svg/subtitle.svg",
	"./suitcase.svg": "./src/assets/images/svg/suitcase.svg",
	"./timer.svg": "./src/assets/images/svg/timer.svg",
	"./toast-check.svg": "./src/assets/images/svg/toast-check.svg",
	"./user-photo-default.svg": "./src/assets/images/svg/user-photo-default.svg",
	"./wavy-circle-check.svg": "./src/assets/images/svg/wavy-circle-check.svg",
	"./window-gear.svg": "./src/assets/images/svg/window-gear.svg",
	"./x-c.svg": "./src/assets/images/svg/x-c.svg",
	"./x-circle.svg": "./src/assets/images/svg/x-circle.svg",
	"./x-red-circle.svg": "./src/assets/images/svg/x-red-circle.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/svg sync recursive \\.svg$";